import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  TreatmentSession,
  TreatmentSessionPayload,
} from "@project/types/treatment-session";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/treatment-sessions`;
const SILENT: RequestConfig = { showNotification: false };

class TreatmentSessionService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<TreatmentSession>> => {
    return fetchListPage<TreatmentSession>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<TreatmentSession | undefined> => {
    const data = await get<ApiItemResponse<TreatmentSession> | TreatmentSession>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: TreatmentSessionPayload
  ): Promise<TreatmentSession | undefined> => {
    const data = await post<
      ApiItemResponse<TreatmentSession> | TreatmentSession,
      TreatmentSessionPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Partial<TreatmentSessionPayload>
  ): Promise<TreatmentSession | undefined> => {
    const data = await patch<
      ApiItemResponse<TreatmentSession> | TreatmentSession,
      Partial<TreatmentSessionPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const treatmentSessionService = new TreatmentSessionService();
